import { useEffect, useState } from "react";
import { useApi, formatDate } from "@/lib/api";

export function AuditLog({ refreshKey }) {
  const api = useApi();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit", { params: { limit: 150 } }).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [api, refreshKey]);
  if (!rows) return <p className="text-sm text-slate-500">Caricamento…</p>;
  if (!rows.length) return <p className="text-sm text-slate-500" data-testid="audit-empty">Nessuna attività registrata</p>;
  return (
    <div className="max-h-[420px] overflow-auto -mx-1 px-1">
      <table className="w-full text-sm" data-testid="audit-table">
        <thead className="text-left text-xs text-slate-500 sticky top-0 bg-white">
          <tr><th className="py-2 pr-3 font-medium">Data</th><th className="py-2 pr-3 font-medium">Azione</th><th className="py-2 pr-3 font-medium">Progetto</th><th className="py-2 font-medium">Utente</th></tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} data-testid="audit-row">
              <td className="py-2 pr-3 whitespace-nowrap text-slate-500 text-xs">{formatDate(r.at, true)}</td>
              <td className="py-2 pr-3 text-slate-800">{r.action}</td>
              <td className="py-2 pr-3 text-slate-600 max-w-[220px] truncate">{r.project_name || "—"}</td>
              <td className="py-2 text-slate-500 text-xs max-w-[220px] truncate">{r.email || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
